import React from 'react';
import PropTypes from 'prop-types';

import { useExperimentInfo } from './ExperimentsContext';
import ExperimentOriginal from './ExperimentOriginal';
import ExperimentVariant from './ExperimentVariant';

export default function Experiment({
  id,
  env,
  children,
  experimentRoutes,
}) {
  if (!id) {
    throw new Error('The useExperiment requires the experiment id');
  }

  const { variant: activeVariant } = useExperimentInfo(id, experimentRoutes);

  if (activeVariant === null && env !== 'production' && env !== 'test') {
    console.warn(`The experiment with id "${id}" was not found or is not active. The Original value is going to be rendered.`);
  }

  return (
    React.Children.map(children, child => (
      React.cloneElement(child, {
        activeVariant,
      })
    ))
  );
}

Experiment.Original = ExperimentOriginal;
Experiment.Variant = ExperimentVariant;

Experiment.defaultProps = {
  env: process.env.NODE_ENV,
  experimentRoutes: undefined,
};

Experiment.propTypes = {
  children: PropTypes.node.isRequired,
  env: PropTypes.string,
  experimentRoutes: PropTypes.arrayOf(PropTypes.string),
  id: PropTypes.string.isRequired,
};
